import Footer from "../components/Footer";
import ServicesComp from "../components/ServicesComp";
export default function Services() {
  return (
    <div className="main_basket">
      <ServicesComp />
      <Footer />
    </div>
  );
}
